// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__10HP2","disabled":"FileBtn_disabled__17e0y","warn":"FileBtn_warn__3m69q","fade":"FileBtn_fade__2IH60"};